import { render, staticRenderFns } from "./Pricing1.vue?vue&type=template&id=2c81cdff&"
import script from "./Pricing1.vue?vue&type=script&lang=js&"
export * from "./Pricing1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports